import { gql } from '@apollo/client'

export const pendingMatchFragment = gql`
  fragment PendingMatchFields on PendingMatch {
    id
    sharecode
    courseProgress
    createdAt
    updatedAt
    pendingMatchDate: date
    isNotFound
    errorCode
    status
    platform
    # Only a retired CS:GO-era match has a map and score here. The alias keeps
    # the nullable score apart from Match's non-null one in the matches query.
    map
    retiredScore: score {
      ct
      t
    }
  }
`

export const pendingMatchQuery = gql`
  query PendingMatch($id: ID!) {
    pendingMatch(id: $id) {
      ...PendingMatchFields
    }
  }

  ${pendingMatchFragment}
`

export const pendingMatchSubscription = gql`
  subscription PendingMatchUpdated($id: ID!) {
    pendingMatch(id: $id) {
      ...PendingMatchFields
    }
  }

  ${pendingMatchFragment}
`
